<template>
  <div class="admin">
    <TheHeader />
    <button class="mobile-nav-toggle" @click="navOpen = !navOpen">
      {{ navOpen ? `Menü ausblenden (${currentMenuLabel})` : `Menü anzeigen (${currentMenuLabel})` }}
    </button>
    <nav :class="{ 'mobile-hidden': !navOpen }">
      <router-link to="/admin" activeClass="active">Dienstplan</router-link>
      <router-link to="/admincoredata">Arztdaten</router-link>
      <router-link to="/adminlog">Log</router-link>
      <router-link to="/admincalllist">Anrufliste</router-link>
      <button @click="logout">Logout</button>
    </nav>
    <router-view></router-view>
  </div>
  <TheFooter />
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { computed, ref } from "vue";
import TheFooter from "@/components/TheFooter.vue";
import TheHeader from "@/components/TheHeader.vue";
const store = useStore();
const router = useRouter();
const route = useRoute();
const navOpen = ref(false);
const currentMenuLabel = computed(() => {
  if (route.path === "/admincoredata") return "Arztdaten";
  if (route.path === "/adminlog") return "Log";
  if (route.path === "/admincalllist") return "Anrufliste";
  return "Dienstplan";
});
function logout() {
  store.dispatch("auth/logout").then(router.push("/"));
}
</script>
<style scoped>
.admin {
  padding-bottom: 96px;
}
button:hover {
  background-color: #91bd2a;
}

@media (max-width: 1023px) {
  .admin {
    padding-bottom: 170px;
  }
}

@media (min-width: 421px) {
  .mobile-nav-toggle {
    display: none;
  }
}
</style>
